import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-download-password-dialog',
  templateUrl: './download-password-dialog.component.html',
  styleUrls: ['./download-password-dialog.component.scss'],
})
export class DownloadPasswordDialogComponent {
  @Input() visible: boolean = false;
  @Input() warningMessage: string = '';
  @Output() onClose = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<string>();

  enteredPassword: string = '';

  closeDialog(): void {
    this.enteredPassword = '';
    this.onClose.emit();
  }

  submitPassword(): void {
    this.onSubmit.emit(this.enteredPassword);
  }
}